import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import stl from "@/pages/checkout/pre-checkout/PreCheckout.module.css";
import { useTranslation } from "@i18n";
import { useAribFinance } from "@/common/Contexts/AribFinanceContext";
import RadioCard from "@/pages/checkout/pre-checkout/RadioCard/RadioCard";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import { SHOW_DEBUG_INFO } from "@globalConfig";
var PreCheckoutMainForm = function PreCheckoutMainForm(_ref) {
  var _checkoutOrder$campai, _checkoutOrder$story_, _checkoutOrder$story_2, _checkoutOrder$campai2, _checkoutOrder$story_4, _checkoutOrder$story_5, _checkoutOrder$campai3, _checkoutOrder$story_7, _checkoutOrder$story_8;
  var checkoutOrder = _ref.checkoutOrder,
    setShowCampaignModal = _ref.setShowCampaignModal,
    handleChange = _ref.handleChange,
    setEvent = _ref.setEvent,
    value = _ref.value,
    loading = _ref.loading;
  var _useTranslation = useTranslation(["web_pre_checkout"]),
    t = _useTranslation.t;
  var action__clearLocalStorageData = useAribFinance().actions.action__clearLocalStorageData;
  useEffect(function () {
    action__clearLocalStorageData();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioCard, {
    g4Data: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer,
    setCampaignModal: setShowCampaignModal,
    campaignData: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$campai = checkoutOrder.campaigns) === null || _checkoutOrder$campai === void 0 ? void 0 : _checkoutOrder$campai.cash,
    storyText: t("كيف تشتري سيارتك من سيارة؟", {
      ns: "web_pre_checkout"
    }),
    story: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$story_ = checkoutOrder.story_section) === null || _checkoutOrder$story_ === void 0 ? void 0 : (_checkoutOrder$story_2 = _checkoutOrder$story_.cash_story) === null || _checkoutOrder$story_2 === void 0 ? void 0 : _checkoutOrder$story_2.data.map(function (story, idx) {
      var _checkoutOrder$story_3;
      return /*#__PURE__*/React.createElement("div", {
        key: "stry" + idx,
        className: "singleStry",
        "data-color": "linear-gradient(180deg, rgba(48,75,165,1) 0%, rgba(74,167,221,1) 100%);"
      }, /*#__PURE__*/React.createElement("strong", {
        style: {
          textAlign: "center"
        }
      }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$story_3 = checkoutOrder.story_section) === null || _checkoutOrder$story_3 === void 0 ? void 0 : _checkoutOrder$story_3.cash_story.title), /*#__PURE__*/React.createElement("img", {
        src: story.image,
        alt: "story"
      }));
    }),
    name: "action",
    checked: +value === 1,
    onChange: function onChange(e) {
      handleChange(e);
      setEvent("cash");
    },
    value: 1,
    className: stl.radioCard
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.card
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.testDriveSection
  }, /*#__PURE__*/React.createElement("strong", {
    className: "TDCaseA"
  }, t("كاش", {
    ns: "web_pre_checkout"
  })), /*#__PURE__*/React.createElement("p", {
    className: "TDCaseA"
  }, t("اضمن حجز السيارة من خلال دفع عربون مخصوم من قيمة السيارة", {
    ns: "web_pre_checkout"
  }))), loading && /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 23,
    divWidth: 60,
    appearance: {
      color: "green"
    }
  }), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.arboun) && /*#__PURE__*/React.createElement("div", {
    className: stl.priceSection
  }, /*#__PURE__*/React.createElement("strong", null, checkoutOrder.arboun, /*#__PURE__*/React.createElement("span", {
    className: "text-2xl"
  }, t("ريال", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("span", null, t("مستردة", {
    ns: "web_pre_checkout"
  }))))), /*#__PURE__*/React.createElement(RadioCard, {
    dataName: "ARIB-Finance",
    g4Data: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer,
    setCampaignModal: setShowCampaignModal,
    campaignData: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$campai2 = checkoutOrder.campaigns) === null || _checkoutOrder$campai2 === void 0 ? void 0 : _checkoutOrder$campai2.finance,
    isFinance: true,
    storyText: t("كيف تمول سيارتك من سيارة؟", {
      ns: "web_pre_checkout"
    }),
    story: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$story_4 = checkoutOrder.story_section) === null || _checkoutOrder$story_4 === void 0 ? void 0 : (_checkoutOrder$story_5 = _checkoutOrder$story_4.finance_story) === null || _checkoutOrder$story_5 === void 0 ? void 0 : _checkoutOrder$story_5.data.map(function (story, idx) {
      var _checkoutOrder$story_6;
      return /*#__PURE__*/React.createElement("div", {
        key: "stry" + idx,
        className: "singleStry"
      }, /*#__PURE__*/React.createElement("strong", {
        style: {
          textAlign: "center"
        }
      }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$story_6 = checkoutOrder.story_section) === null || _checkoutOrder$story_6 === void 0 ? void 0 : _checkoutOrder$story_6.finance_story.title), /*#__PURE__*/React.createElement("img", {
        src: story.image,
        alt: "story"
      }));
    }),
    name: "action",
    checked: +value === 4,
    onChange: function onChange(e) {
      handleChange(e);
      setEvent("finance");
    },
    value: 4,
    className: [stl.radioCard, stl.freefinanceRadio].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.card
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.testDriveSection
  }, /*#__PURE__*/React.createElement("strong", {
    className: "TDCaseA"
  }, SHOW_DEBUG_INFO && "ARIB -> ", t("قدم طلب تمويل", {
    ns: "web_pre_checkout"
  })), /*#__PURE__*/React.createElement("p", {
    className: "TDCaseA"
  }, t("حمل الوثائق المطلوبة (هوية، رخصة قيادة واثبات راتب) وابدأ اجراءات طلب التمويل.", {
    ns: "web_pre_checkout"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.priceSection
  }, /*#__PURE__*/React.createElement("strong", null, t("مجاناً", {
    ns: "web_pre_checkout"
  }))))), /*#__PURE__*/React.createElement(RadioCard, {
    dataName: "Finance-normal-flow",
    g4Data: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer,
    setCampaignModal: setShowCampaignModal,
    campaignData: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$campai3 = checkoutOrder.campaigns) === null || _checkoutOrder$campai3 === void 0 ? void 0 : _checkoutOrder$campai3.finance,
    isFinance: true,
    storyText: t("كيف تمول سيارتك من سيارة؟", {
      ns: "web_pre_checkout"
    }),
    story: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$story_7 = checkoutOrder.story_section) === null || _checkoutOrder$story_7 === void 0 ? void 0 : (_checkoutOrder$story_8 = _checkoutOrder$story_7.finance_story) === null || _checkoutOrder$story_8 === void 0 ? void 0 : _checkoutOrder$story_8.data.map(function (story, idx) {
      var _checkoutOrder$story_9;
      return /*#__PURE__*/React.createElement("div", {
        key: "stry" + idx,
        className: "singleStry"
      }, /*#__PURE__*/React.createElement("strong", {
        style: {
          textAlign: "center"
        }
      }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$story_9 = checkoutOrder.story_section) === null || _checkoutOrder$story_9 === void 0 ? void 0 : _checkoutOrder$story_9.finance_story.title), /*#__PURE__*/React.createElement("img", {
        src: story.image,
        alt: "story"
      }));
    }),
    name: "action",
    checked: +value === 3,
    onChange: function onChange(e) {
      handleChange(e);
      setEvent("finance");
    },
    value: 3,
    className: [stl.radioCard, stl.freefinanceRadio].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.card
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.testDriveSection
  }, /*#__PURE__*/React.createElement("strong", {
    className: "TDCaseA"
  }, SHOW_DEBUG_INFO && "Normal finance->", t("قدم طلب تمويل", {
    ns: "web_pre_checkout"
  })), /*#__PURE__*/React.createElement("p", {
    className: "TDCaseA"
  }, t("حمل الوثائق المطلوبة (هوية، رخصة قيادة واثبات راتب) وابدأ اجراءات طلب التمويل.", {
    ns: "web_pre_checkout"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.priceSection
  }, /*#__PURE__*/React.createElement("strong", null, t("مجاناً", {
    ns: "web_pre_checkout"
  }))))));
};
export default PreCheckoutMainForm;